import { useEffect } from 'react';

const useDeviceDimension = () => {
  useEffect(() => {
    const setRealDeviceHeight = () => {
      const viewportHeight = window.innerHeight;
      document.documentElement.style.setProperty('--device-view-height', `${viewportHeight}px`);
    };
    setRealDeviceHeight();
    window.addEventListener('resize', setRealDeviceHeight);
    return () => {
      window.removeEventListener('resize', setRealDeviceHeight);
    };
  }, []);
};

export default useDeviceDimension;
